import { render, staticRenderFns } from "./ScannerInput.vue?vue&type=template&id=b97fa684&scoped=true&"
import script from "./ScannerInput.vue?vue&type=script&lang=js&"
export * from "./ScannerInput.vue?vue&type=script&lang=js&"
import style0 from "./ScannerInput.vue?vue&type=style&index=0&id=b97fa684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97fa684",
  null
  
)

export default component.exports